import { Copy, Check } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export const inviteLink = (token) => `${window.location.origin}/invite/${token}`;

export async function copyText(text) {
  try {
    await navigator.clipboard.writeText(text);
  } catch {
    const t = document.createElement("textarea");
    t.value = text;
    document.body.appendChild(t);
    t.select();
    document.execCommand("copy");
    t.remove();
  }
}

export default function InviteLinkDialog({ tech, onClose }) {
  const [copied, setCopied] = useState("");
  if (!tech) return null;
  const link = inviteLink(tech.invite_token);
  const message = `Hi ${tech.name}, you've been invited to AccessBridge. Open this link to set your password and sign in: ${link} (or sign in with Google using ${tech.email}). The link works for 14 days.`;
  const copy = async (kind, text) => {
    await copyText(text);
    setCopied(kind);
    toast.success(kind === "link" ? "Invite link copied" : "Invite message copied");
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg bg-card" data-testid="invite-link-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl">Invite {tech.name}</DialogTitle>
          <DialogDescription>Send this link by text or email. {tech.name} opens it, sets a password and is signed in.</DialogDescription>
        </DialogHeader>
        <div className="flex gap-2">
          <Input readOnly value={link} data-testid="invite-link-input" onFocus={(e) => e.target.select()} />
          <Button type="button" variant="outline" onClick={() => copy("link", link)} data-testid="copy-invite-link-button">
            {copied === "link" ? <Check size={14} /> : <Copy size={14} />}
          </Button>
        </div>
        <p className="text-sm text-muted-foreground border rounded-md p-3 break-all" data-testid="invite-message">{message}</p>
        <DialogFooter className="gap-2">
          <Button variant="outline" onClick={() => copy("message", message)} data-testid="copy-invite-message-button"><Copy size={14} /> Copy message</Button>
          <Button onClick={onClose} data-testid="invite-done-button">Done</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
